module.exports = __webpack_public_path__ + "static/media/Ordenanza Tributaria 2023 (1).aafbe34d.pdf";